export default "/institutions/brand-hipercard.svg";